import { TYPES } from "./auth.type";

const initState = {
  isLogged: null,
  phone: null,
};

const authReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.FIREBASE_AUTH_STATUS:
      return {
        ...state,
        isLogged: payload,
      };
    case TYPES.FIREBASE_AUTH_PHONE:
      return {
        ...state,
        phone: payload,
      };
    default:
      return state;
  }
};

export default authReducer;
